import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_generic_doc_expenses_adjustment_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
	adjustment_status: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
	posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_journal_error: fromDatatype.VarcharDatatypeInterface;
  docline_update_status: fromDatatype.VarcharDatatypeInterface;
  docline_update_error: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  old_expenses: fromDatatype.JsonDatatypeInterface;
  new_expenses: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_generic_doc_expenses_adjustment_RowClass implements bl_fi_generic_doc_expenses_adjustment_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
  guid_doc_hdr: fromDatatype.GuidDataFieldInterface;
	adjustment_status: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
	posting_journal: fromDatatype.VarcharDatatypeInterface;
  posting_journal_error: fromDatatype.VarcharDatatypeInterface;
  docline_update_status: fromDatatype.VarcharDatatypeInterface;
  docline_update_error: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  old_expenses: fromDatatype.JsonDatatypeInterface;
  new_expenses: fromDatatype.JsonDatatypeInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
